// extracted by mini-css-extract-plugin
export default {"tabList":"tabList__CuJ","tabItem":"tabItem_LNqP"};